import React from 'react'
import AboutUs from '../about-us'

const AboutUsEs = () => {
    return <AboutUs languageCode="es" />
}

export default AboutUsEs
